import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUiStore = defineStore('ui', () => {
  const isStickyHeader = ref<boolean>(false)

  function setStickyHeader(value: boolean): void {
    isStickyHeader.value = value
  }

  return {
    isStickyHeader,
    setStickyHeader
  }
})
